export default __webpack_public_path__ + "static/media/drumbstick.913cd3fe.svg";